import React from 'react';
import { Eyebrow } from './Eyebrow';
const metrics = [{
  value: '240+',
  label: 'Practical pages'
}, {
  value: '300+',
  label: 'Ready-to-use sessions'
}, {
  value: '120+',
  label: 'Visual reference cards'
}, {
  value: '6',
  label: 'Complete volumes'
}];
const coverage = ['Beginner Foundations', 'Intermediate Standards', 'Advanced Improvisation', 'All Solo & Group Settings', 'Games & Ensemble Play', 'Assessment & Progress Tracking'];
export function SystemOverview() {
  return <section aria-labelledby="system-heading" className="bg-paper py-16 sm:py-24" data-id="element-240" data-mp="px6hgi9eh9oo">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-241" data-mp="13vwha5nltngq">
        <div className="grid items-center gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,26rem)] lg:gap-16" data-id="element-242" data-mp="13xhbtv9x56el">
          <div data-id="element-243" data-mp="yz5zndw5ijt7">
            <Eyebrow data-id="element-244" data-mp="2fbco8w9fv124">The most complete system for jazz guitar educators</Eyebrow>
            <h2 id="system-heading" className="mt-5 font-display text-3xl font-semibold leading-[1.05] text-ink sm:text-5xl" data-id="element-245" data-mp="2fdfp6bc4qelm">
              Jazz Teacher&rsquo;s Arsenal&trade;
            </h2>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-ink-soft sm:text-lg" data-id="element-246" data-mp="2857ahzqtgsdq">
              Over 240 pages of complete lesson plans, professional exercises, standards, technique
              guides, and classroom management tools &mdash; everything already prepared for you.
            </p>

            <dl className="mt-10 grid grid-cols-2 gap-y-8 border-t border-paper-300 pt-8 sm:grid-cols-4" data-id="element-247" data-mp="1kgei2d9el2nv">
              {metrics.map(metric => <div key={metric.label} data-id="element-248" data-mp="1pf93lmyr95bo">
                  <dt className="sr-only" data-id="element-249" data-mp="1udiwts0x5vun">{metric.label}</dt>
                  <dd data-id="element-250" data-mp="1ubzezwzm7cqr">
                    <span className="block font-display text-3xl font-semibold leading-none text-brass sm:text-4xl" data-id="element-251" data-mp="1z4sn8uual37l">
                      {metric.value}
                    </span>
                    <span className="mt-2 block max-w-[9rem] text-[11px] font-semibold uppercase tracking-label text-ink-muted" data-id="element-252" data-mp="11nkesgl56yzh">
                      {metric.label}
                    </span>
                  </dd>
                </div>)}
            </dl>
          </div>

          <div className="border border-paper-300 bg-paper-100 p-8" data-id="element-253" data-mp="tofft6190dos">
            <p className="text-[11px] font-semibold uppercase tracking-label text-brass-dark" data-id="element-254" data-mp="18ck0gfjv2za7">
              Total coverage
            </p>
            <p className="mt-2 font-display text-2xl leading-snug text-ink" data-id="element-255" data-mp="13glfl1xqrzej">
              Beginner through advanced jazz
            </p>
            <ul className="mt-7 divide-y divide-paper-300" data-id="element-256" data-mp="aqctiz034uuo">
              {coverage.map((item, index) => <li key={item} className="flex items-baseline gap-4 py-3.5 text-sm text-ink-soft first:pt-0 last:pb-0" data-id="element-257" data-mp="pndnl95r11wb" data-mpi={index}>
                  <span className="tabular-nums text-xs text-brass" data-id="element-258" data-mp="2120nsysmjpzk">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}